//Todo: jQuery for old modals. Remove when new version is implemented
import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;

import accordion from './jquery/accordion.js';
import calculator from './jquery/calculator.js';
import calculatorV2 from './jquery/calculatorV2.js';
import featherlight from 'featherlight';
import modal from './jquery/modal.js';
import tooltip from './jquery/tooltip.js';

import '@hotwired/turbo';
import sentry from './external_services/sentry.js';
//import messageflow from './external_services/messageflow.js';
import carousel from './helper/carousel.js';
import articleTracker from './helper/article_tracker.js';
import contentNavigation from './helper/content_navigation.js';
import datahref from './helper/datahref.js';
import jqueryForms from '../../placetel/js/form';
import filterElements from './helper/filterElements.js';
import form from './helper/form.js';
import headroom from './helper/headroom.js';
import lazyload from './helper/lazyload.js';
import typewriter from './helper/typewriter.js';
import navigation from './helper/navigation.js';
import displayPlaceTelJobsInConsole from './helper/placetel_seeker.js';
import pricingblock from './helper/pricingblock.js';
import scrollbarWidth from './helper/scrollbar_width.js';
//import sitesearch360 from './helper/sitesearch360.js';
import tables from './helper/tables.js';
import toggle from './helper/toggle.js';
import togglePrice from './helper/togglePrice.js';
import {horizontalSlider} from './components/HorizontalSlider';
import {showSelectedElementAndHideOthers} from './components/ShowSelectedElementAndHideOthers';
import Alpine from 'alpinejs';
import playVideoFromUrlHash from './helper/play_video_from_url_hash';

function initDocumentJavaScript() {
  sentry(document.querySelector('meta[name="sentry-dsn"]')?.getAttribute('content'));

  // prevent multiple start()
  if (!window.Alpine) {
    try {
      window.Alpine = Alpine;
      window.Alpine.start();
    } catch (e) {
      console.error('Could not init alpine');
      console.error(e);
    }
  }

  //messageflow();
  accordion();
  articleTracker();
  calculator();
  calculatorV2();
  carousel();
  contentNavigation();
  datahref();
  featherlight();
  filterElements();
  form();
  headroom();
  lazyload();
  modal();
  navigation();
  pricingblock();
  scrollbarWidth();
  //sitesearch360();
  tables();
  toggle();
  togglePrice();
  tooltip();
  typewriter();
  jqueryForms();
  playVideoFromUrlHash();
}

document.addEventListener('alpine:init', () => {
  Alpine.data('horizontalSlider', () => ({ ...horizontalSlider }));
  Alpine.data('showSelectedElementAndHideOthers', () => ({ ...showSelectedElementAndHideOthers }));
});
document.addEventListener('turbo:load', initDocumentJavaScript);

if (!document.location.href.startsWith('http://localhost')) {
  displayPlaceTelJobsInConsole();
}
